/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Order_Totals_RowInputs */

const vi_order_totals_row = /** @type {(inputs: Order_Totals_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng ${i?.count} đơn`)
};

/**

* @param {Order_Totals_RowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_totals_row = /** @type {((inputs: Order_Totals_RowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Totals_RowInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_totals_row(inputs)
});